import Cookies from "universal-cookie";

export async function fetchAPI(url, callback, options = {}) {
  const cookies = new Cookies();
  const token = cookies.get("X-CSRF-Token");
  const method = options.method || "GET";
  const body = JSON.stringify(options.body ? options.body : {});

  const fetchJSON = await fetch(url, {
    method: method,
    redirect: "manual",
    body: method == "GET" ? null : body,
    headers: {
      "X-CSRF-Token": token,
      "Content-Type": 'application/json'
    }
  }).then(response => {
    return response.json();
  }).then((json) => {
    if(callback) {
      callback(json);
    }
    return json;
  }).catch((error) =>{
    console.log(error);
    if(options.bypassReportError) {
      return;
    }
    try {
      if(options['onError']) {
        options['onError'](error);
      }
      reportError(error, "fetchAPI");
    }
    catch(e) {
      console.log("Failed to call onError");
    }
  })

  return fetchJSON;
}


const reportError = async (error, uuid) => {
  try {
    await fetchAPI("/webapi/errors", ()=>{
      
    },{
      method: "POST",
      bypassReportError: true,
      headers: {
        "Content-Type": "application/json",
      },
      body: {
        error: {
          error: error.toString(),
          stack: error.stack,
          location: window.location.href,
          uuid: uuid
        }
      },
    });
  } catch (e) {
    console.log("Error reporting error", e);
    console.error(e);
  }
}